export default [
    {
        path: '/userResearch',
        component: () => import(/* webpackChunkName: "userResearch" */ '@/pages/userResearch/index.vue'),
        meta: {
            title: '用户调研',
        },
    },
    {
        path: '/userResearch/login',
        name: 'UserResearchLogin',
        component: () => import(/* webpackChunkName: "userResearch" */ '@/pages/userResearch/login.vue'),
        meta: {
            title: '登录',
            keepAlive: true,
        },
    },
    {
        path: '/userResearch/examineAgreement',
        component: () => import(/* webpackChunkName: "userResearch" */ '@/pages/userResearch/examineAgreement.vue'),
        meta: {
            title: '亚朵用户有奖调研隐私政策',
        },
    },
    {
        path: '/userResearch/questionAuthNoticeAgreement',
        name: 'questionAuthNoticeAgreement',
        component: () => import(/* webpackChunkName: "userResearch" */ '@/pages/userResearch/questionAuthNoticeAgreement.vue'),
        meta: {
            title: '问卷授权告知书',
        },
    },
];
